import {
  ASSIGNMENT_STATUS_OPTIONS,
  assignmentStatusLabel,
  type MyAssignment,
} from '@entities/meetings';
import {
  Section,
  SectionLabel,
  MeetingList,
  MyRow,
  MyLink,
  MeetingTitle,
  MeetingMeta,
  StatusSelect,
} from './styles';

interface MyAssignmentsSectionProps {
  assignments: MyAssignment[];
  onSetStatus: (id: string, status: string, meetingId: string) => void;
}

export function MyAssignmentsSection({ assignments, onSetStatus }: MyAssignmentsSectionProps) {
  if (assignments.length === 0) return null;

  return (
    <Section>
      <SectionLabel>Мои поручения</SectionLabel>
      <MeetingList>
        {assignments.map((a) => (
          <MyRow key={a.id}>
            <MyLink to="/agents/meetings/register">
              <MeetingTitle>{a.text}</MeetingTitle>
              <MeetingMeta>
                {a.meeting_title} · Срок: {a.due_text ?? '—'}
              </MeetingMeta>
            </MyLink>
            <StatusSelect
              value={a.status}
              onChange={(e) => onSetStatus(a.id, e.target.value, a.meeting_id)}
              aria-label="Статус поручения"
            >
              {!ASSIGNMENT_STATUS_OPTIONS.some((o) => o.value === a.status) && (
                <option value={a.status} disabled>
                  {assignmentStatusLabel(a.status)}
                </option>
              )}
              {ASSIGNMENT_STATUS_OPTIONS.map((o) => (
                <option value={o.value} key={o.value}>
                  {o.label}
                </option>
              ))}
            </StatusSelect>
          </MyRow>
        ))}
      </MeetingList>
    </Section>
  );
}
